"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canVillageBroadcast = exports.isVillageServiceExpired = exports.resolveEffectiveModules = exports.EFFECTIVE_MODULE_ORDER = exports.BOOTSTRAP_PLAN_ID = exports.PlanConfigurationType = exports.ModuleName = void 0;
var ModuleName;
(function (ModuleName) {
    ModuleName["ADVERTISEMENT_MODULE"] = "ADVERTISEMENT_MODULE";
    ModuleName["COUPON_MODULE"] = "COUPON_MODULE";
    ModuleName["ACTIVITY_MODULE"] = "ACTIVITY_MODULE";
    ModuleName["VILLAGER_INFO_MODULE"] = "VILLAGER_INFO_MODULE";
    ModuleName["LOTTERY_MODULE"] = "LOTTERY_MODULE";
    ModuleName["PETITION_MODULE"] = "PETITION_MODULE";
    ModuleName["DOCUMENT_MODULE"] = "DOCUMENT_MODULE";
    ModuleName["INFO_MANAGER_MODULE"] = "INFO_MANAGER_MODULE";
    ModuleName["CARE_MODULE"] = "CARE_MODULE";
    ModuleName["MEMBER_MODULE"] = "MEMBER_MODULE";
    ModuleName["BROADCAST_MODULE"] = "BROADCAST_MODULE";
    ModuleName["SHOP_MODULE"] = "SHOP_MODULE";
    ModuleName["LEEHI_AI_MODULE"] = "LEEHI_AI_MODULE";
    ModuleName["DIGITAL_CARD_MODULE"] = "DIGITAL_CARD_MODULE";
    ModuleName["PRIVACY_DECLARATION_MODULE"] = "PRIVACY_DECLARATION_MODULE";
    ModuleName["AI_ASSISTANT_MODULE"] = "AI_ASSISTANT_MODULE";
})(ModuleName || (exports.ModuleName = ModuleName = {}));
var PlanConfigurationType;
(function (PlanConfigurationType) {
    PlanConfigurationType["BASE_PLAN"] = "BASE_PLAN";
    PlanConfigurationType["CUSTOM_OVERRIDE"] = "CUSTOM_OVERRIDE";
})(PlanConfigurationType || (exports.PlanConfigurationType = PlanConfigurationType = {}));
exports.BOOTSTRAP_PLAN_ID = {
    chiefDefault: 'default-chief-plan',
    nonChiefDefault: 'default-non-chief-plan',
    legacyBackfill: 'legacy-village-backfill-plan',
};
exports.EFFECTIVE_MODULE_ORDER = Object.values(ModuleName);
const resolveEffectiveModules = (basePlan, overridePlan) => {
    const moduleMap = new Map();
    for (const plan of [basePlan, overridePlan]) {
        if (!plan || !plan.modules)
            continue;
        for (const moduleLimit of plan.modules) {
            moduleMap.set(moduleLimit.moduleName, moduleLimit);
        }
    }
    const effectiveModules = [];
    for (const moduleName of exports.EFFECTIVE_MODULE_ORDER) {
        const moduleLimit = moduleMap.get(moduleName);
        if (!moduleLimit)
            continue;
        effectiveModules.push(moduleLimit);
        moduleMap.delete(moduleName);
    }
    for (const moduleLimit of moduleMap.values()) {
        effectiveModules.push(moduleLimit);
    }
    return effectiveModules;
};
exports.resolveEffectiveModules = resolveEffectiveModules;
const isVillageServiceExpired = (expiredAt, now) => {
    if (!expiredAt)
        return false;
    const expired = expiredAt instanceof Date ? expiredAt : new Date(expiredAt);
    if (Number.isNaN(expired.getTime()))
        return false;
    return now.getTime() > expired.getTime();
};
exports.isVillageServiceExpired = isVillageServiceExpired;
const canVillageBroadcast = (modules, village, now) => {
    if (!modules.some((moduleLimit) => moduleLimit.moduleName === ModuleName.BROADCAST_MODULE)) {
        return false;
    }
    if (!village)
        return true;
    if (village.isSuspended)
        return false;
    return !(0, exports.isVillageServiceExpired)(village.expiredAt, now);
};
exports.canVillageBroadcast = canVillageBroadcast;
//# sourceMappingURL=village.interface.js.map